import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-commitments-from-applicant',
  templateUrl: './commitments-from-applicant.component.html',
  styleUrls: ['./commitments-from-applicant.component.css'],
})
export class CommitmentsFromApplicantComponent implements OnInit {
  // Form group for commitments
  commitments: FormGroup;
  private saveApi = environment.url + 'coe/commitments/save';
  private getApi = environment.url + 'coe/commitments/get?id=';
  // Variables to hold file values and names
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.commitments = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      hostInsitution: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      industrialPartner: [''],
      industrialpartnercontribution: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      totalbuiluparea: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      incubationSpace: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      incubationSpaceDoc: [''],
      incubationSpaceDocName: [''],
      technicalLaboratories: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      technicalLaboratoriesDoc: [''],
      technicalLaboratoriesDocName: [''],
      conferenceHall: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      conferenceHallDoc: [''],
      conferenceHallDocName: [''],
      networkinGroom: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      networkinGroomDoc: [''],
      networkinGroomDocName: [''],
      cafeteria: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      cafeteriaDoc: [''],
      cafeteriaDocName: [''],
      officeSpace: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      officeSpaceDoc: [''],
      officeSpaceDocName: [''],
      techTransferHub: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      techTransferHubDoc: [''],
      techTransferHubDocName: [''],
      pilotPlant: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      pilotPlantDoc: [''],
      pilotPlantDocName: [''],
    });
  }

  ngOnInit(): void {
    this.getDataApi();
  }

  showForm: boolean = false;
  get setting() {
    return this.commitments.controls;
  }
  // API call to get data
  getValue: any = {};
  disableBtn: boolean;
  show;
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.commitments.patchValue(data);
          if (this.getValue.incubationSpaceDoc) {
            this.FileValue = this.getValue.incubationSpaceDoc;
            this.FileName = this.getValue.incubationSpaceDocName;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
          if (this.getValue.technicalLaboratoriesDoc) {
            this.FileValue2 = this.getValue.technicalLaboratoriesDoc;
            this.FileName2 = this.getValue.technicalLaboratoriesDocName;
            this.disNames2 = '✔ Uploaded';
            this.disName2 = '✔ Uploaded';
          }
          if (this.getValue.conferenceHallDoc) {
            this.FileValue3 = this.getValue.conferenceHallDoc;
            this.FileName3 = this.getValue.conferenceHallDocName;
            this.disNames3 = '✔ Uploaded';
            this.disName3 = '✔ Uploaded';
          }
          if (this.getValue.networkinGroomDoc) {
            this.FileValue4 = this.getValue.networkinGroomDoc;
            this.FileName4 = this.getValue.networkinGroomDocName;
            this.disNames4 = '✔ Uploaded';
            this.disName4 = '✔ Uploaded';
          }
          if (this.getValue.cafeteriaDoc) {
            this.FileValue5 = this.getValue.cafeteriaDoc;
            this.FileName5 = this.getValue.cafeteriaDocName;
            this.disNames5 = '✔ Uploaded';
            this.disName5 = '✔ Uploaded';
          }
          if (this.getValue.officeSpaceDoc) {
            this.FileValue6 = this.getValue.officeSpaceDoc;
            this.FileName6 = this.getValue.officeSpaceDocName;
            this.disNames6 = '✔ Uploaded';
            this.disName6 = '✔ Uploaded';
          }
          if (this.getValue.techTransferHubDoc) {
            this.FileValue7 = this.getValue.techTransferHubDoc;
            this.FileName7 = this.getValue.techTransferHubDocName;
            this.disNames7 = '✔ Uploaded';
            this.disName7 = '✔ Uploaded';
          }
          if (this.getValue.pilotPlantDoc) {
            this.FileValue8 = this.getValue.pilotPlantDoc;
            this.FileName8 = this.getValue.pilotPlantDocName;
            this.disNames8 = '✔ Uploaded';
            this.disName8 = '✔ Uploaded';
          }
        }
      });
  }
  // File upload functionality
  // Variables to hold file values and names
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);

      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile2: any = [];
  url2: any;
  FileValue2: any = '';
  FileName2: any;
  documentValues2 = [];
  disName2;
  disNames2;
  maxSizeMB2 = 5;
  logoCheck2 = false;
  fileErrorShow2 = false;
  fileError2 = false;
  fileUpload2(event) {
    this.selecetdFile2 = event.target.files[0];
    if (event.target.files && this.selecetdFile2) {
      const fileSizeMB = this.selecetdFile2.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB2) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile2.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile2);
        reader.onload = () => {
          this.url2 = reader.result;
          let spl = this.url2.split(',');
          this.FileValue2 = spl[1];
          this.FileName2 = this.selecetdFile2.name;
          this.disName2 = '✔ Uploaded';
          this.fileError2 = false;
          this.fileErrorShow2 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile3: any = [];
  url3: any;
  FileValue3: any = '';
  FileName3: any;
  documentValues3 = [];
  disName3;
  disNames3;
  maxSizeMB3 = 5;
  logoCheck3 = false;
  fileErrorShow3 = false;
  fileError3 = false;
  fileUpload3(event) {
    this.selecetdFile3 = event.target.files[0];
    if (event.target.files && this.selecetdFile3) {
      const fileSizeMB = this.selecetdFile3.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB3) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile3.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile3);
        reader.onload = () => {
          this.url3 = reader.result;
          let spl = this.url3.split(',');
          this.FileValue3 = spl[1];
          this.FileName3 = this.selecetdFile3.name;
          this.disName3 = '✔ Uploaded';
          this.fileError3 = false;
          this.fileErrorShow3 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile4: any = [];
  url4: any;
  FileValue4: any = '';
  FileName4: any;
  documentValues4 = [];
  disName4;
  disNames4;
  maxSizeMB4 = 5;
  logoCheck4 = false;
  fileErrorShow4 = false;
  fileError4 = false;
  fileUpload4(event) {
    this.selecetdFile4 = event.target.files[0];
    if (event.target.files && this.selecetdFile4) {
      const fileSizeMB = this.selecetdFile4.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB4) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile4.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile4);
        reader.onload = () => {
          this.url4 = reader.result;
          let spl = this.url4.split(',');
          this.FileValue4 = spl[1];
          this.FileName4 = this.selecetdFile4.name;
          this.disName4 = '✔ Uploaded';
          this.fileError4 = false;
          this.fileErrorShow4 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile5: any = [];
  url5: any;
  FileValue5: any = '';
  FileName5: any;
  documentValues5 = [];
  disName5;
  disNames5;
  maxSizeMB5 = 5;
  logoCheck5 = false;
  fileErrorShow5 = false;
  fileError5 = false;
  fileUpload5(event) {
    this.selecetdFile5 = event.target.files[0];
    if (event.target.files && this.selecetdFile5) {
      const fileSizeMB = this.selecetdFile5.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB5) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile5.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile5);
        reader.onload = () => {
          this.url5 = reader.result;
          let spl = this.url5.split(',');
          this.FileValue5 = spl[1];
          this.FileName5 = this.selecetdFile5.name;
          this.disName5 = '✔ Uploaded';
          this.fileError5 = false;
          this.fileErrorShow5 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile6: any = [];
  url6: any;
  FileValue6: any = '';
  FileName6: any;
  documentValues6 = [];
  disName6;
  disNames6;
  maxSizeMB6 = 5;
  logoCheck6 = false;
  fileErrorShow6 = false;
  fileError6 = false;
  fileUpload6(event) {
    this.selecetdFile6 = event.target.files[0];
    if (event.target.files && this.selecetdFile6) {
      const fileSizeMB = this.selecetdFile6.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB6) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile6.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile6);
        reader.onload = () => {
          this.url6 = reader.result;
          let spl = this.url6.split(',');
          this.FileValue6 = spl[1];
          this.FileName6 = this.selecetdFile6.name;
          this.disName6 = '✔ Uploaded';
          this.fileError6 = false;
          this.fileErrorShow6 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile7: any = [];
  url7: any;
  FileValue7: any = '';
  FileName7: any;
  documentValues7 = [];
  disName7;
  disNames7;
  maxSizeMB7 = 5;
  logoCheck7 = false;
  fileErrorShow7 = false;
  fileError7 = false;
  fileUpload7(event) {
    this.selecetdFile7 = event.target.files[0];
    if (event.target.files && this.selecetdFile7) {
      const fileSizeMB = this.selecetdFile7.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB7) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile7.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile7);
        reader.onload = () => {
          this.url7 = reader.result;
          let spl = this.url7.split(',');
          this.FileValue7 = spl[1];
          this.FileName7 = this.selecetdFile7.name;
          this.disName7 = '✔ Uploaded';
          this.fileError7 = false;
          this.fileErrorShow7 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Additional file upload functionalities for other documents
  // Each file upload function follows the same pattern as above
  selecetdFile8: any = [];
  url8: any;
  FileValue8: any = '';
  FileName8: any;
  documentValues8 = [];
  disName8;
  disNames8;
  maxSizeMB8 = 5;
  logoCheck8 = false;
  fileErrorShow8 = false;
  fileError8 = false;
  fileUpload8(event) {
    this.selecetdFile8 = event.target.files[0];
    if (event.target.files && this.selecetdFile8) {
      const fileSizeMB = this.selecetdFile8.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB8) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile8.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile8);
        reader.onload = () => {
          this.url8 = reader.result;
          let spl = this.url8.split(',');
          this.FileValue8 = spl[1];
          this.FileName8 = this.selecetdFile8.name;
          this.disName8 = '✔ Uploaded';
          this.fileError8 = false;
          this.fileErrorShow8 = false;
          this.saveBtn('false');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // Function to cancel file upload and reset form
  cancleBtn() {
    this.fileError = true;
    this.FileValue = '';
    this.FileValue2 = '';
    this.FileName = '';
    this.FileName2 = '';
    this.disName = '';
    this.disName2 = '';
    this.fileError2 = true;
    this.fileError = true;
    this.showForm = false;
    this.commitments.reset();
  }
  // Function to prevent Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // Function to save and continue
  saveAndContinue;
  saveBtn(val) {
    this.saveAndContinue = val;
    let getform = this.commitments.value;
    if (this.commitments.invalid) {
      this.commitments.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.FileValue != '') {
        this.fileError = false;
        getform.incubationSpaceDoc = this.FileValue;
        getform.incubationSpaceDocName = this.FileName;
      }
      if (this.FileValue2 != '') {
        this.fileError2 = false;
        getform.technicalLaboratoriesDoc = this.FileValue2;
        getform.technicalLaboratoriesDocName = this.FileName2;
      }
      if (this.FileValue3 != '') {
        this.fileError3 = false;
        getform.conferenceHallDoc = this.FileValue3;
        getform.conferenceHallDocName = this.FileName3;
      }
      if (this.FileValue4 != '') {
        this.fileError4 = false;
        getform.networkinGroomDoc = this.FileValue4;
        getform.networkinGroomDocName = this.FileName4;
      }
      if (this.FileValue5 != '') {
        this.fileError5 = false;
        getform.cafeteriaDoc = this.FileValue5;
        getform.cafeteriaDocName = this.FileName5;
      }
      if (this.FileValue6 != '') {
        this.fileError6 = false;
        getform.officeSpaceDoc = this.FileValue6;
        getform.officeSpaceDocName = this.FileName6;
      }
      if (this.FileValue7 != '') {
        this.fileError7 = false;
        getform.techTransferHubDoc = this.FileValue7;
        getform.techTransferHubDocName = this.FileName7;
      }
      if (this.FileValue8 != '') {
        this.fileError8 = false;
        getform.pilotPlantDoc = this.FileValue8;
        getform.pilotPlantDocName = this.FileName8;
      }
      if (
        this.fileError == false &&
        this.fileError2 == false &&
        this.fileError3 == false &&
        this.fileError4 == false &&
        this.fileError5 == false &&
        this.fileError6 == false &&
        this.fileError7 == false &&
        this.fileError8 == false
      ) {
        getform.applicationId = sessionStorage.getItem('applicationId');
        this.getdata.amizhthLoader('show');
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus == 'Success') {
            this.notify.notifysuccess(data.responseStatus);
            this.getDataApi();
            if (this.saveAndContinue == 'true') {
              this.router.navigateByUrl('admin/coe/workplan');
            }
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
      }
    }
  }
}
